<template>
  <div class="snack-bar" :class="variant">
    <div class="text bold">{{ text }}</div>
    <slot name="secondary"/>
  </div>
</template>

<script>

export default {
  name: 'SnackBar',
  props: {
    text: {
      type: String,
      required: true,
    },
    variant: {
      type: String,
      required: true,
      validator: val => ['danger', 'warning', 'success', 'incomplete'].includes(val),
    },
  },
};

</script>

<style scoped lang="scss">
  @import '../scss/riseup-colors';

  .snack-bar {
    height: 36px;
    display: flex;
    align-items: center;
    justify-content: space-between;

    font-family: SimplerPro;
    font-size: 12px;

    &.danger {
      background-color: $riseup_danger_red;
    }

    &.warning {
      background-color: $riseup_yellow;
    }

    &.success {
      background-color: $riseup_green;
    }

    &.incomplete {
      background-color: $riseup_orange;
    }

    .text {
      color: $riseup_white;

      &.bold {
        font-weight: bold;
      }
    }
  }
</style>
